(function () {
  function initPromo(section) {
    const track = section.querySelector('[data-promo-track]');
    const slides = section.querySelectorAll('[data-promo-slide]');
    if (!track || slides.length <= 1) return;

    let current = 0;

    function move(direction) {
      current += direction;
      if (current < 0) current = slides.length - 1;
      if (current >= slides.length) current = 0;
      track.style.transform = 'translateX(-' + current * 100 + '%)';
    }

    section.querySelectorAll('[data-promo-prev]').forEach((btn) => {
      btn.addEventListener('click', () => move(-1));
    });

    section.querySelectorAll('[data-promo-next]').forEach((btn) => {
      btn.addEventListener('click', () => move(1));
    });
  }

  document.querySelectorAll('[data-emerson-promo]').forEach(initPromo);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-emerson-promo]');
    if (section) initPromo(section);
  });
})();
